<template lang="html">
  <div class="orange" v-if="Commission && Commission.wizard">
    <ModalForm :showModal="showModal" :action="Commission.wizard.add_commission.action">
      <template slot="form">
        <CustomForm
          :pages="Commission.wizard.add_commission.pages"
          :action="Commission.wizard.add_commission.action"
          :buttonText="Commission.wizard.add_commission.actionBtn"
          :showTitle="false">
        </CustomForm>
      </template>
    </ModalForm>

    <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
      <div></div>
      <div class="d-flex">
        <div class="d-none d-md-block">
          <button class="btn btn-sm pd-x-15 btn-white btn-uppercase" @click="openAddCommissionModal()">
            <i data-feather="mail" class="wd-10 mg-r-5"></i> Add Commission
          </button>
        </div>
        <div class="d-none d-md-block mg-l-10">
          <label class="btn btn-sm pd-x-15 btn-white btn-uppercase m-0" style="cursor: pointer;">
            <i data-feather="upload" class="wd-10 mg-r-5"></i> Upload Commission
            <input type="file" accept=".xlsx, .xls" @change="handleCommissionUpload" style="display: none;">
          </label>
        </div>
      </div>
    </div>

    <div class="contents">
      <CustomTable
        :tableFields="Commission.table.table_fields"
        :tableData="commissions"
        :title="Commission.table.title"
        :subtitle="Commission.table.subtitle"
        :searchFields="Commission.table.searchFields"
        :rowData="Commission.table.rowData">
      </CustomTable>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    console.log('add.commission.vue: created hook started');
    console.log('add.commission.vue: Models.Commission', Models.Commission);
    this.Commission = Models.Commission || {};

    Event.$on("commission:view", (payload) => {
      console.log("add.commission.vue: commission:view event triggered", payload);
      this.$router.push({
        name: "Configs-Commission-ViewCommission",
        params: { id: payload.commission.ref_no },
      });
    });

    Event.$on("form:submit", async (payload) => {
      console.log('add.commission.vue: form:submit event triggered', payload);
      if (payload.action === this.Commission.wizard.add_commission.action) {
        console.log("add.commission.vue: Form submitted with data:", payload.formData);
        await this.addCommission(payload.formData);
        this.showModal = false;
      }
    });

    Event.$on("modal:close", () => {
      console.log("add.commission.vue: modal:close event triggered");
      this.showModal = false;
    });

    console.log('add.commission.vue: Commission after created', this.Commission);
    console.log('add.commission.vue: created hook completed');
  },
  data() {
    console.log('add.commission.vue: data function called');
    return {
      Commission: Models.Commission || {},
      commissions: [],
      formData: {},
      showModal: false,
    };
  },
  methods: {
    openAddCommissionModal() {
      console.log('add.commission.vue: openAddCommissionModal called');
      this.showModal = true;
      console.log('add.commission.vue: showModal set to', this.showModal);
    },
    addCommission(data) {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await req.callServerSecureV2({
            service: { name: "underwriting", version: "v1" },
            resource: { name: "commision", version: "v1" },
            action: { name: "createCommision", version: "v1" },
            data: {
              refNo: data.ref_no,
              classOfBusiness: data.class_of_business,
              commissionRate: data.commission_rate.toString()
            }
          });

          // ✅ Consistent string coercion when adding new row
          this.commissions.push({
            _id: data.ref_no || Math.random().toString(36).slice(2),
            ref_no: String(data.ref_no || ''),
            class_of_business: String(data.class_of_business || ''),
            commission_rate: String(data.commission_rate ?? '')
          });

          alert(`Commission ${data.ref_no} successfully added`);

          Event.$emit("form:action-complete", {
            action: this.Commission.wizard.add_commission.action,
            clear: true,
          });
          resolve(true);
        } catch (err) {
          console.log(err);
          Event.$emit("form:action-error", {
            action: this.Commission.wizard.add_commission.action,
          });
          alert(err.response?.data?.err_msg || 'An error occurred while adding the commission');
          reject(err);
        }
      });
    },
    handleCommissionUpload(event) {
      const file = event.target.files[0];
      if (!file) {
        console.log("No file selected.");
        return;
      }
      if (!file.name.match(/\.(xls|xlsx)$/)) {
        alert("Please upload a valid Excel file (.xls or .xlsx)");
        return;
      }
      console.log("Selected Excel file:", file);
    },
  }, 
  async mounted() {
    console.log('add.commission.vue: mounted hook started');

    try {
      const res = await req.callServerSecureV2({
        service: { name: "underwriting", version: "v1" },
        resource: { name: "commision", version: "v1" },
        action: { name: "fetchCommisions", version: "v1" },
        data: {}
      });

      console.log('add.commission.vue: fetchCommissions response', res);

      const items =res.data.result.data
console.log("items", res.data.result.data)
      // ✅ Normalize all fields to strings and keep a stable _id
      const toStr = (v) => (v === null || v === undefined) ? '' : String(v).trim();

      this.commissions = items
        .map(item => {
          const src = item.props ?? item;
          return {
            _id: src._id || src.id || toStr(src.refNo) || Math.random().toString(36).slice(2),
            ref_no: toStr(src.refNo ?? src.ref_no),
            class_of_business: toStr(src.classOfBusiness ?? src.class_of_business),
            commission_rate: toStr(src.commissionRate ?? src.commission_rate)
          };
        })
        .filter(r => r.ref_no || r.class_of_business || r.commission_rate);

      console.log('add.commission.vue: commissions initialized', this.commissions);
    } catch (err) {
      console.error('add.commission.vue: Error fetching commissions', err);
      alert(err.response?.data?.err_msg || err.message || 'An error occurred while fetching commissions');
      this.commissions = [];
    } finally {
      Event.$emit("loader:show", false);
      console.log('add.commission.vue: mounted hook completed');
    }
  },
};
</script>

<style lang="less">
</style>